import { SharedColumnRegistry } from "../../types/columnRegistry"
// @ts-expect-error: the import is outside of TS' scope
import columnRegistry from "../../../shared/src/columnRegistry.yaml"

export function getColumnRegistryConfig(): SharedColumnRegistry {
  return columnRegistry as SharedColumnRegistry
}
